/**
 * Combines extra corporate quote fields into contact[body] before submit.
 */
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('lc-corp-quote-form');
  if (!form) return;

  form.addEventListener('submit', () => {
    const body = form.querySelector('[name="contact[body]"]');
    const company = form.querySelector('[data-lc-corp-field="company"]')?.value?.trim();
    const quantity = form.querySelector('[data-lc-corp-field="quantity"]')?.value?.trim();
    const budget = form.querySelector('[data-lc-corp-field="budget"]')?.value?.trim();
    const delivery = form.querySelector('[data-lc-corp-field="delivery_date"]')?.value?.trim();
    const occasion = form.querySelector('[data-lc-corp-field="occasion"]')?.value?.trim();
    const userMessage = body?.value?.trim() || '';

    const parts = [];
    if (company) parts.push(`Company: ${company}`);
    if (quantity) parts.push(`Quantity: ${quantity}`);
    if (budget) parts.push(`Budget per gift: ${budget}`);
    if (occasion) parts.push(`Occasion: ${occasion}`);
    if (delivery) parts.push(`Delivery date: ${delivery}`);
    if (userMessage) parts.push(`Message: ${userMessage}`);

    if (body) {
      body.value = parts.join('\n');
    }
  });
});
